import { MediaDtoSchema } from "@/modules/common/media/api/mediaDto"
import { HUImageDtoSchema } from "@/modules/dtos/imageDto"
import { UserDtoSchema } from "@/modules/profile/userProfile/userDto"
import { ScoreSetCompletionDtoSchema } from "@/modules/scores/scoreForms/gateway/scoreDto"
import { ExerciseCategories } from "@/modules/sessions/sessionDetails/blocks/exerciseBlock/exerciseTypes"
import { ScoreDifficultyEnum, ScoreType } from "@modules/scores/scoreTypes"

import { z } from "zod"

export const DashboardScoreDtoSchema = z
  .object({
    value: z.number(),
    type: z.string(),
  })
  .meta({ id: "DashboardScoreDtoSchema" })

export type DashboardScoreDto = z.infer<typeof DashboardScoreDtoSchema>

const TieBreakDtoSchema = z.object({
  time: z.number().nullable(),
  threshold: z.number(),
})

export const ScoreboardScoreDtoSchema = z
  .object({
    // value: z.number().nullable(), // deprecated
    valueDecimal: z.number().nullable(),
    additionalValueDecimal: z.number().nullable(),
    personalRecord: z.boolean().nullable(),
    timeCapExceeded: z.boolean().nullable(),
    difficulty: z.enum(ScoreDifficultyEnum).nullable(),
    note: z.string().nullable(),
    noteAndMediaIsVisible: z.boolean(),
    medias: z.array(MediaDtoSchema).nullable(),
    reps: z.number().nullable(),
    tieBreaks: z.array(TieBreakDtoSchema).nullable(),
    scoreSetCompletions: z.array(ScoreSetCompletionDtoSchema).nullable(),
  })
  .meta({ id: "ScoreboardScoreDtoSchema" })

export type ScoreboardScoreDto = z.infer<typeof ScoreboardScoreDtoSchema>

export const ExerciseDashboardDtoSchema = z
  .object({
    totalScore: z.number(),
    topUsers: z.array(
      z.object({
        score: DashboardScoreDtoSchema,
        user: UserDtoSchema,
      }),
    ),
    lastRecordUsers: z.array(
      z.object({
        score: DashboardScoreDtoSchema,
        user: UserDtoSchema,
      }),
    ),
  })
  .meta({ id: "ExerciseDashboardDtoSchema" })

export type ExerciseDashboardDto = z.infer<typeof ExerciseDashboardDtoSchema>

export const ScoreDtoSchema = z
  .object({
    score: ScoreboardScoreDtoSchema.nullable(),
    scoreType: z.enum(ScoreType),
    exerciseId: z.string(),
    exerciseCategory: z.enum(ExerciseCategories),
    otherCategory: z.string().nullable(),
    orderIndex: z.number(),
  })
  .meta({ id: "ScoreDtoSchema" })

export type ScoreDto = z.infer<typeof ScoreDtoSchema>

export const SessionScoreDtoSchema = z
  .object({
    user: UserDtoSchema.nullable(),
    scores: z.array(ScoreDtoSchema),
  })
  .meta({ id: "SessionScoreDtoSchema" })

export type SessionScoreDto = z.infer<typeof SessionScoreDtoSchema>

export const ScoreboardRankingDtoSchema = z
  .object({
    position: z.number(),
    userId: z.string(),
    firstname: z.string(),
    lastname: z.string(),
    score: ScoreboardScoreDtoSchema.nullable(),
    scoreType: z.enum(ScoreType),
    avatar: HUImageDtoSchema.nullable(),
  })
  .meta({ id: "ScoreboardRankingDtoSchema" })

export type ScoreboardRankingDto = z.infer<typeof ScoreboardRankingDtoSchema>
